/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// MENU > ITEM
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	menuitem: {
		cursor: 'pointer',
		borderBottom: replacePXinStringWithEM(`1px solid ${theme.color.neutral.light.swatch}`),
		color: theme.color.primary.dark.swatch,
		fontSize: 'inherit',
		display: 'block',
		minWidth: pxToEm(230),
		textAlign: 'left',
		// animation
		transition: theme.animation.general('background'),
		'& .link': {
			width: '100%',
			height: '100%',
			padding: replacePXinStringWithEM(`20px`),
			'& a': {
				width: '100%',
				height: '100%'
			},
			'& .icon': {
				width: pxToEm(15),
				marginRight: pxToEm(20)
			}
		},
		'&.disabled-true': {
			color: theme.color.neutral.light.swatch,
			cursor: 'default',
            pointerEvents: 'none',
		},
		// round corners to match menu
		'&:first-child': {
			borderTopLeftRadius: 'inherit',
			borderTopRightRadius: 'inherit'
		},
		'&:last-child': {
			borderBottomLeftRadius: 'inherit',
			borderBottomRightRadius: 'inherit'
		},
		// hover 
		'&:hover': {
			background: theme.color.secondary.xlight.swatch
		}
	}
});